"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.howManyDaysArePastFromGregorian = void 0;
var is_leap_1 = require("../leap/is-leap");
function howManyDaysArePastFromGregorian(day, Jyear) {
    var temp = Jyear + 621;
    var Day;
    if (is_leap_1.isLeap(temp)) {
        if (day <= 287) {
            Day = day + 79;
        }
        else {
            Day = day - 287;
        }
    }
    else {
        if (day <= 286) {
            Day = day + 79;
        }
        else {
            Day = day - 286;
        }
    }
    return Day;
}
exports.howManyDaysArePastFromGregorian = howManyDaysArePastFromGregorian;
